import { useToast } from '@chakra-ui/react';
import { useState } from 'react';
import { API_URL } from '../api/config';

export interface AccessExportFilters {
  store?: string;
  startDate?: string;
  endDate?: string;
}

export const useAccessExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const toast = useToast();

  const exportAccessData = async (filters: AccessExportFilters = {}) => {
    setIsExporting(true);

    try {
      // Construir parâmetros da query
      const params = new URLSearchParams();
      if (filters.store) params.append('store', filters.store);
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);

      const queryString = params.toString();
      const url = `${API_URL}access/export-by-person${queryString ? `?${queryString}` : ''}`;

      // Fazer requisição para o endpoint
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      });

      if (!response.ok) {
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }

      // Converter resposta para blob
      const blob = await response.blob();

      // Gerar nome do arquivo com data atual
      const today = new Date().toISOString().split('T')[0];
      const filename = `controle_acesso_por_pessoas_${today}.xlsx`;

      // Fazer download do arquivo
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      // Mostrar toast de sucesso
      toast({
        title: 'Exportação concluída',
        description: `Arquivo ${filename} baixado com sucesso`,
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

    } catch (error) {
      console.error('Erro ao exportar dados:', error);
      
      // Mostrar toast de erro
      toast({
        title: 'Erro na exportação',
        description: error instanceof Error ? error.message : 'Erro desconhecido ao exportar dados',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    isExporting,
    exportAccessData,
  };
}; 